export const childless = [
  "labor",
  "article",
  "provisionalItem",
  "optional",
  "additional",
];
